import { z } from 'zod';

export const MarketSchema = z.object({
  retailUnit: z.string(),
  countryName: z.string(),
  languageCodes: z.array(z.string()),
});

export const MarketsSchema = z.array(MarketSchema);
